import { createApp } from 'vue'
import App from './App.vue'
// import Vue from 'vue'
import MetaInfo from 'vue-meta-info'
// Vue.use()
// import VueMeta from 'vue-meta'
// Vue.use(VueMeta);
createApp(App).mount('#app').use(MetaInfo)
